import { useBreadcrumbContext } from "@/context/breadcrumb";
import { ChevronRight } from "lucide-react";
import Link from "next/link";
import React, { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

const DefaultHeaderBreadcrumb = () => {
  const { breadcrumbs } = useBreadcrumbContext();

  if (!breadcrumbs || breadcrumbs.length === 0) {
    return <></>;
  }

  return (
    <div className="flex items-center gap-1 -ml-1 text-sm text-cb-gray-700">
      {breadcrumbs
        .map((breadcrumb, idx) =>
          breadcrumb.href ? (
            <Link
              key={breadcrumb.key}
              href={breadcrumb.href}
              className="px-1 py-0.5 rounded text-cb-gray-700 hover:text-cb-gray-700 hover:bg-cb-gray-100 transition-all"
            >
              {breadcrumb.label}
            </Link>
          ) : (
            <span
              key={breadcrumb.key}
              className={twMerge(
                "px-1 py-0.5",
                breadcrumbs.length - 1 === idx && "text-cb-gray-900"
              )}
            >
              {breadcrumb.label}
            </span>
          )
        )
        .reduce((accu: ReactNode[] | null, elem: ReactNode, idx: number) => {
          return accu === null
            ? [elem]
            : [
                ...accu,
                <ChevronRight key={`delimiter-${idx}`} className="w-4 h-4" />,
                elem,
              ];
        }, null)}
    </div>
  );
};

export default React.memo(DefaultHeaderBreadcrumb);
